import { config } from '../../projects/config';

export const chains = {
    mainnet: 30,
    testnet: 31
};

export const currentChainId = config.environment.chainId;

export const blockExplorers = {
    30: 'https://explorer.rsk.co',
    31: 'https://explorer.testnet.rsk.co'
};

export const btcExplorer = {
    30: 'https://live.blockcypher.com/btc',
    31: 'https://live.blockcypher.com/btc-testnet'
};

export const readNodes = {
    30: 'wss://mainnet.sovryn.app/ws',
    31: 'wss://testnet.sovryn.app/ws'
};

export const fastBtcApis = {
    30: 'https://fastbtc.sovryn.app/',
    31: 'https://fastbtc.test.sovryn.app/'
};

export const sovrynBackendUrls = {
    30: 'https://backend.sovryn.app',
    31: 'https://api.test.sovryn.app'
};

export const databaseRpcNodes = {
    30: 'https://backend.sovryn.app/rpc',
    31: 'https://api.test.sovryn.app/rpc'
};
